<div class="g-top-nav">
  <a routerLink="/">
    <img src="../../../../assets/img/menutech-full-logo.svg" alt="logo" />
  </a>
  @if (register()) {
    <div class="btn-wrapper">
      <span class="trial-text">{{ 'auth.login.side.trial' | transloco }}</span>
      {{ ' ' }}
      <span
        ><a routerLink="/registration" [queryParams]="{ lang: lang() }">{{
          'auth.login.side.trial-button' | transloco
        }}</a></span
      >
    </div>
    <button
      mat-stroked-button
      routerLink="/registration"
      [queryParams]="{ lang: lang() }"
      class="register-button"
    >
      {{ 'auth.registration.actions.register' | transloco }}
    </button>
  }
</div>
